export default __webpack_public_path__ + "static/0229-b636b5ffc6573fe004c3f7768d08ca93.png";